import { TopologySubscription } from '../../../../../services/eventingApi';
import { inputClass } from './ui';

interface ConsumerSelectProps {
  targets: TopologySubscription[];
  value: string;
  onChange: (value: string) => void;
}

const ConsumerSelect = ({ targets, value, onChange }: ConsumerSelectProps) => (
  <label className="flex flex-col gap-1">
    Consumidor (target)
    <select className={inputClass} value={value} onChange={(change) => onChange(change.target.value)} required>
      {targets.map((subscription) => (
        <option key={subscription.subscriptionArn} value={subscription.consumer}>
          {subscription.consumer}
        </option>
      ))}
    </select>
  </label>
);

export default ConsumerSelect;
